export function extrairPartesEndereco(texto: string): string {
    let cidade = texto.match(/Cidade:([^:]+)/)?.[1]?.trim();
    const estado = texto.match(/Estado:\s*([^:]+)$/)?.[1]?.trim();
    cidade = cidade?.replace(" Estado", "").replace(" Bairro", "").trim();
    return cidade ? [cidade, estado].filter(Boolean).join(", ") : "";
}